import { Component, OnInit } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss']
})
export class CustomSnackbarComponent implements OnInit {
  snackbarMessage : string;
  constructor( private _snackRef: MatSnackBarRef<CustomSnackbarComponent>,
               private dataSource: SnackBarService) { }

  ngOnInit(): void {
    this.snackbarMessage = this.dataSource.snackBarMessage;
  }
  dismiss(): void {
    this._snackRef.dismiss();
  }
  
}
